import initModules from '../initModules';

function addToDataLayer(element) {
  const numberSearchResults = element.firstElementChild.getAttribute('data-search-results');
  if (numberSearchResults) {
    window.wtDataLayer.numberOfSearchResults += parseInt(numberSearchResults, 10);
  }
}

/**
 * Class controls the lazy loading of content from API
 */
class BfvLazyloadHtml {
  constructor(options = {}) {
    this.$root = options.element;
    this.apiName = this.$root.getAttribute('data-url');
    this.checkStatus = true;
  }

  async init() {
    window.divae.restApi
      .loadData(this.apiName, 'application/xhtml+xml', {}, this.checkStatus)
      .then((_response) => {
        this.$root.innerHTML = _response;

        addToDataLayer(this.$root);
        initModules({ rootElement: this.$root });
      });
  }
}

export default BfvLazyloadHtml;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvLazyloadHtml/index.js